module.exports = "https://www.gc-qa.gnp.com.mx/a73e4285733f1f45c5ba1d7c145d00c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Corners.png
// module id = 8052
// module chunks = 0